import { useEffect } from 'react';
import { useGlobal } from '../../hooks';
import { useFetchConfig } from './useConfig';
import { setSentryAccount } from '../../sentry';

export const ConfigFetcher = (): null => {
    const { accountId, setConfig, config, setIsReady } = useGlobal();
    const { data, isLoading } = useFetchConfig({
        accountId: accountId,
        enabled: !!accountId && !config,
    });

    // When config data is loaded, replace the filter groups
    useEffect(() => {
        if (data && !isLoading) {
            setConfig(data);
            setSentryAccount(data.account.name);
        }
        setIsReady(!isLoading);
    }, [data, isLoading]);

    return null;
};
